var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAllSprints = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8177 4.12702C5.19971 4.12702 3.83748 5.23322 3.44257 6.73465L2.31763 6.43616C2.84407 4.43466 4.6585 2.95837 6.8177 2.95837L6.8177 4.12702Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3083 7.63297C10.3083 9.56925 8.74552 11.1389 6.8177 11.1389H1V12.3076L6.8177 12.3076L12.6541 12.3076V14.0417L15 11.6856L12.6541 9.3294V11.1389H9.89622C10.8625 10.2824 11.4719 9.02915 11.4719 7.63297C11.4719 5.05126 9.38812 2.95837 6.8177 2.95837L6.8177 4.12702C8.74552 4.12702 10.3083 5.69669 10.3083 7.63297ZM5.40143 6.79481L2.16353 3.5427V6.79481H5.40143Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAllSprints);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/all-sprints.f394a05bf8009ddb2ba3222fddefe5b4.svg";